import { render, staticRenderFns } from "./AddressBar.vue?vue&type=template&id=4d0d53e4&scoped=true"
import script from "./AddressBar.vue?vue&type=script&lang=js"
export * from "./AddressBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0d53e4",
  null
  
)

export default component.exports